import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { SimulationColumnsItemEntity } from './simulation-columns-item.entity';
import { SimulationColumnsListEntity } from './simulation-columns-list.entity';

@Injectable()
export class SimulationColumnListProvider {
	private readonly columnList: SimulationColumnsListEntity;

	public constructor() {
		this.columnList = SimulationColumnsListEntity.build([
			{
				field: 'type',
				alias: '',
				type: '',
				isSearchable: false,
				isFilterable: false,
				visibleIndex: 0,
			},
			{
				field: 'alias',
				alias: $localize`:@@subscription.columns.config.list.column.alias:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				visibleIndex: 1,
			},
			{
				field: 'label',
				alias: $localize`:@@subscription.columns.config.list.column.label:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				visibleIndex: 2,
			},
			{
				field: 'description',
				alias: $localize`:@@subscription.columns.config.list.column.description:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				visibleIndex: 3,
			},
			{
				field: 'isHashed',
				alias: $localize`:@@subscription.columns.config.list.column.hashable:`,
				type: 'boolean',
				isSearchable: false,
				isFilterable: true,
				visibleIndex: 4,
			},
		]);
	}

	public getList(): SimulationColumnsListEntity {
		return this.columnList;
	}

	public setListElements(
		elements: Map<string, SimulationColumnsItemEntity>
	): SimulationColumnsListEntity {
		return this.columnList.setElements(elements);
	}
}
